import { FC, useContext } from 'react';

import { TableSection } from '../Table/Table.types';
import { TableSectionContext } from '../Table/TableSectionContext';
import { TableCellStyled, TableHeadCellStyled } from './TableCell.styles';
import { TableCellProps } from './TableCell.types';

const TableCell: FC<TableCellProps> = ({ children, css, ref: _ref, ...rest }) => {
  const headerCtx = useContext(TableSectionContext);

  if (headerCtx === undefined) {
    throw new Error('No TableSectionContext provided.');
  }

  return headerCtx.variant === TableSection.HEADER ? (
    <TableHeadCellStyled css={css} {...rest}>
      {children}
    </TableHeadCellStyled>
  ) : (
    <TableCellStyled css={css} {...rest}>
      {children}
    </TableCellStyled>
  );
};

export default TableCell;
